@if (landingPageDataService.isLoaded()) {
  <!-- md:w-3/5 -->
  <div class="landing__page container mx-auto my-12">
    <div class="mx-auto lg:w-3/5 md:w-4/5 bg-white rounded-2xl">
      <div class="author__container flex flex-col gap-4 p-4">
        <app-author></app-author>
        <app-statistics></app-statistics>
      </div>

      <div class="flex flex-col gap-4 px-6 py-4">
        <app-post-details></app-post-details>

        @if (!landingPageDataService.isQrCode()) {
          <app-post-url></app-post-url>
        }
        @defer {
          @if (pt.isMobile) {
            <app-ad [ad-width]="300" [ad-height]="250"></app-ad>
          } @else {
            <div class="flex justify-center gap-6">
              <app-ad [ad-width]="300" [ad-height]="250"></app-ad>
              <app-ad [ad-width]="300" [ad-height]="250"></app-ad>
            </div>
          }
        }
        <app-post-activity></app-post-activity>
        <div>
          <app-post-comments></app-post-comments>
          <app-report-post></app-report-post>
        </div>
      </div>
    </div>
    <div class="mt-6">
      <app-ad [ad-width]="970" [ad-height]="250"></app-ad>
    </div>
  </div>
}
